export type CheckoutSubmitSource = "card" | "express";

/**
 * Whether Become-a-Member checkout should refuse submit because the Stripe
 * PaymentElement is not ready yet.
 *
 * Express Checkout / wallets share `handleSubmit` but do not mount
 * PaymentElement — requiring readiness there caused `checkout_blocked`.
 *
 * @param options.submitSource - Card form vs Express Checkout confirm
 * @param options.hasSelectedPaymentMethod - Saved card selected
 * @param options.isChangingPlan - Plan-change path (no new payment element)
 * @param options.isPaymentElementReady - PaymentElement `onReady` fired
 * @returns True when card checkout must wait for PaymentElement
 */
export const shouldBlockCheckoutForPaymentElement = (options: {
	submitSource: CheckoutSubmitSource;
	hasSelectedPaymentMethod: boolean;
	isChangingPlan: boolean;
	isPaymentElementReady: boolean;
}): boolean => {
	const {
		submitSource,
		hasSelectedPaymentMethod,
		isChangingPlan,
		isPaymentElementReady,
	} = options;

	if (isPaymentElementReady) {
		return false;
	}

	if (isChangingPlan || hasSelectedPaymentMethod) {
		return false;
	}

	// Wallets confirm without PaymentElement mounted / ready.
	if (submitSource === "express") {
		return false;
	}

	return true;
};
